import { getDevMode } from "../api/aquastrong";

export const selectionBase = () =>
  getDevMode() ? "/selection/series-dev" : "/selection/series";